import axios from '@/helpers/axios';
import { serRoadshowApi } from '@/helpers/apis';
import { ICheckStockAvailabilityPayload, IGetSERDeviceListPayload } from '@/actions/serroadshow/models/types';

export const getDeviceListForSerFlow = (payload: IGetSERDeviceListPayload) => {
  const url = serRoadshowApi.GET_DEVICE_LIST_FOR_SER_FLOW;
  return axios.post(url, payload);
};

export const checkStockAvailability = (payload: ICheckStockAvailabilityPayload) => {
  const url = serRoadshowApi.CHECK_STOCK_AVAILABILITY;
  return axios.post(url, payload);
};
